// logoActions.js
import axios from '../../interceptor/axios-config';
import config from '../../config';
import {
  FETCH_LOGO_REQUEST,
  FETCH_LOGO_SUCCESS,
  FETCH_LOGO_FAILURE,
} from './logoTypes';

// API Endpoint
const GET_LOGO_URL = `${config.apiBaseUrl}/logo/getLogo.php`;

// Action to fetch logo
export const fetchLogo = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_LOGO_REQUEST });
  
      try {
        const response = await axios.get(GET_LOGO_URL, {
          responseType: 'blob', // Important: Set response type to 'blob' to handle binary data
        });
  
        const imageUrl = URL.createObjectURL(response.data); // Convert blob to a usable image URL
  
        dispatch({
          type: FETCH_LOGO_SUCCESS,
          payload: imageUrl,
        });
      } catch (error) {
        dispatch({
          type: FETCH_LOGO_FAILURE,
          payload: error.message,
        });
      }
    };
  };
  
